// actions.js
import axios from 'axios';

// actions
export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const SET_SUMMIT = 'SET_SUMMIT';

export const GET_DATA_CUSTOMER = "FETCH_DATA_CUSTOMER";
export const GET_DATA_CUSTOMER_DETAILS ="GET_DATA_CUSTOMER_DETAILS"
export const SET_DATA_NOTIFICATION_REMARK = "SET_DATA_NOTIFICATION_REMARK"
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA"
export const GET_DATA_EVENT = "GET_DATA_EVENT"
export const _GET_ALL_DETIALS = "_GET_ALL_DETIALS"